export enum Tab {
  WithVoucher = 'with-voucher',
  WithoutVoucher = 'without-voucher',
}
